<div class="p-3 mt-1 card border rounded">
  <!-- Header -->
  <div class="mb-3 border-bottom border-secondary-subtle">
    <div class="d-flex flex-column flex-md-row justify-content-between gap-2">
      <div>
        <p class="m-0 text-dark fw-bold fs-4">
          {{ 'CONTRACT.SIDE_COSTS' | translate }}
        </p>
        <p class="m-0 text-muted">
          {{ 'CONTRACT.SIDECOSTS_DESC' | translate }}
        </p>
      </div>
      <div class="text-md-end">
        <button (click)="onEdit()" class="btn btn-primary btn-sm cursor-pointer">
          <i class="las la-edit"></i>{{ 'CONTRACT.EDIT' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Side costs list -->
  <div *ngIf="data()?.sideCosts?.length; else emptySideCosts">
    <div *ngFor="let sideCost of data()?.sideCosts" class="border rounded p-3 mb-3">
      <!-- Top section: billing period & active -->
      <div class="row">
        <div class="col-12 mb-2 mb-md-0">
          <div unitType [type]="sideCost?.utilityRate?.unitType"></div>
        </div>
      </div>

      <!-- Bottom section: date, unit, price -->
      <div class="row mt-3 gy-2">
        <div class="col-12 col-lg-3">
          <p class="fw-bold m-0">{{ 'CONTRACT.BILLING_PERIOD' | translate }}</p>
          <p class="text-muted m-0">{{ sideCost.billingPeriodCode ?? '-' }}</p>
        </div>
        <div class="col-12 col-lg-3">
          <p class="fw-bold m-0">{{ 'CONTRACT.BOOKING_DATE' | translate }}</p>
          <p class="text-muted m-0">
            {{ sideCost.bookingDate | localizedDate:'dd/MM/yyyy' }}
          </p>
        </div>
        <div class="col-6 col-lg-3">
          <p class="fw-bold m-0">{{ 'CONTRACT.PER_UNIT' | translate }}</p>
          <p class="text-muted m-0">{{ sideCost?.utilityRate?.unitType?.type || '-' }}</p>
        </div>
        <div class="col-6 col-lg-3">
          <p class="fw-bold m-0">{{ 'CONTRACT.TARIFF_PRICE' | translate }}</p>
          <p class="text-muted m-0">
            {{ sideCost?.utilityRate?.price ? (sideCost.utilityRate.price | moneyFormat) : '-' }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <ng-template #emptySideCosts>
    <div class="mt-5 text-center">
      <empty-result name="CONTRACT.UTILITY_RATES_EMPTY" text=""></empty-result>
    </div>
  </ng-template>
</div>
